import React, { useEffect } from "react";
import AdminLayout from "../../../layouts/AdminLayout";
import Subheader from "../../../components/ui/Subheader";
import { Space } from "antd";
import IconButton from "../../../components/common/IconButton";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import { getSingleSupplierAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { GetSingleDataParams } from "../../../types/redux";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate, formattedPrice } from "../../../utils/time";
import Loader from "../../../components/common/Loader";

export default function VendorDetailsV2() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { singleSupplier, viewLoading } = useAppSelector(
    (state) => state.supplier
  );
  const {
    supplierName,
    email,
    region,
    area,
    contactNumber,
    latestPO,
    bankInfo,
    territory,
  } = singleSupplier || {};
  const vendorData = [
    { label: "Vendor Name:", value: supplierName || "N/A" },
    { label: "Email:", value: email || "N/A" },
    { label: "Mobile Number:", value: contactNumber?.[0] || "N/A" },
    { label: "Cluster:", value: region?.regionName || "N/A" },
    { label: "Zone:", value: area?.areaName || "N/A" },
    {
      label: "Territory:",
      value: territory?.teritoryName || "N/A",
    },
  ];

  const poInformationData = [
    { label: "PO Number:", value: latestPO?.PONumber || "N/A" },
    {
      label: "Last PO Issuance Date:",
      value: formatDate(latestPO?.POIssuanceDate) || "N/A",
    },
    {
      label: "PO Balance:",
      value: `BTD ${
        latestPO?.POBalance ? formattedPrice(latestPO?.POBalance) : 0
      }`,
    },
    {
      label: "Remaining PO Balance:",
      value: `BTD ${
        latestPO?.remainingPoBalance
          ? formattedPrice(latestPO?.remainingPoBalance)
          : 0
      }`,
    },
    { label: "Usage Percentage:", value: `${latestPO?.usagePercentage || 0}%` },
  ];

  const bankInformationData = [
    { label: "Bank Name:", value: bankInfo?.bankName || "N/A" },
    { label: "Account Holder Name:", value: bankInfo?.accountName || "N/A" },
    { label: "Account Number:", value: bankInfo?.accountNumber || "N/A" },
    { label: "Routing Number:", value: bankInfo?.routingNumber || "N/A" },
    { label: "Branch:", value: bankInfo?.branch || "N/A" },
  ];

  useEffect(() => {
    dispatch(
      getSingleSupplierAsync({
        params: { id } as GetSingleDataParams,
      })
    );
  }, [id, dispatch]);
  return (
    <AdminLayout title="Vendor" headerTitle="Vendor">
      {viewLoading ? (
        <Loader />
      ) : (
        <section className={`shadow-sm bg-white rounded-lg mt-7 pb-7`}>
          <Subheader title="Vendor Details" subTitle={``}>
            <Space size="middle">
              {" "}
              <IconButton
                className="!border-others-header !text-sm !font-normal !rounded-lg !border !text-header !bg-transparent"
                type="default"
                icon={<LeftArrowIcon />}
                onClick={() => navigate(-1)}
              >
                <span>Back</span>
              </IconButton>
            </Space>
          </Subheader>

          <div className="max-w-xl mx-auto px-6 pt-14 min-h-[400px]">
            <div className="flex items-center gap-4 mb-5 mt-5">
              <div className="text-slate-600 text-lg font-semibold">
                General Information
              </div>
              <div className="flex-1 h-px bg-zinc-200"></div>
            </div>

            <div>
              {vendorData.map((item, index) => (
                <div key={index}>
                  <div className="flex justify-between items-center w-full mb-2 mt-2">
                    <div className="text-slate-400 text-base font-medium">
                      {item.label}
                    </div>
                    <div className="text-slate-600 text-base font-medium text-right">
                      {item.value}
                    </div>
                  </div>
                  {index !== vendorData.length - 1 && (
                    <div className="flex-1 h-px bg-zinc-200" />
                  )}
                </div>
              ))}
            </div>

            <div className="flex items-center gap-4 mb-5 mt-5">
              <div className="text-slate-600 text-lg font-semibold">
                PO Information
              </div>
              <div className="flex-1 h-px bg-zinc-200"></div>
            </div>

            <div>
              {poInformationData.map((item, index) => (
                <div key={index}>
                  <div className="flex justify-between items-center w-full mb-2 mt-2">
                    <div className="text-slate-400 text-base font-medium">
                      {item.label}
                    </div>
                    <div
                      className={`text-base font-medium text-right ${
                        index === 3
                          ? "text-[#33AB29]"
                          : index === 2 || index === 4
                          ? "text-[#1B4DFF]"
                          : "text-slate-600"
                      }`}
                    >
                      {item.value}
                    </div>
                  </div>
                  {index !== vendorData.length - 1 && (
                    <div className="flex-1 h-px bg-zinc-200" />
                  )}
                </div>
              ))}
            </div>

            <div className="flex items-center gap-4 mb-5 mt-5">
              <div className="text-slate-600 text-lg font-semibold">
                Bank Information
              </div>
              <div className="flex-1 h-px bg-zinc-200"></div>
            </div>

            <div>
              {bankInformationData.map((item, index) => (
                <div key={index}>
                  <div className="flex justify-between items-center w-full mb-2 mt-2">
                    <div className="text-slate-400 text-base font-medium">
                      {item.label}
                    </div>
                    <div className="text-slate-600 text-base font-medium text-right">
                      {item.value}
                    </div>
                  </div>
                  {index !== vendorData.length - 1 && (
                    <div className="flex-1 h-px bg-zinc-200" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </AdminLayout>
  );
}
